export default __webpack_public_path__ + "static/media/transiluminator-warning.ef463c4c.svg";